import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import {
  FiAlertCircle,
  FiCheckCircle,
  FiXCircle,
  FiInfo,
  FiX,
} from 'react-icons/fi';

import './style.css';

const getIcon = (type, icon) => {
  if (icon) return icon;
  switch (type) {
    case 'success':
      return FiCheckCircle;
    case 'warning':
      return FiAlertCircle;
    case 'info':
      return FiInfo;
    case 'error':
      return FiXCircle;
    default:
      return FiAlertCircle;
  }
};

const Alert = ({
  className,
  closable,
  children,
  icon,
  message,
  showIcon,
  type,
}) => {
  const customClassName = classNames('alert-box', className, `-${type}`);
  const Icon = getIcon(type, icon);

  return (
    <div className={customClassName}>
      <header className="alert-box-header">
        {showIcon || icon ? <Icon className="alert-box-icon" /> : null}
        <p className="alert-title">{message}</p>
        {closable ? <FiX /> : null}
      </header>
      {children ? <div className="alert-box-content">{children}</div> : null}
    </div>
  );
};

Alert.propTypes = {
  type: PropTypes.oneOf(['warning', 'success', 'info', 'error']),
  className: PropTypes.string,
  children: PropTypes.node,
  message: PropTypes.string.isRequired,
  showIcon: PropTypes.bool,
  closable: PropTypes.bool,
  icon: PropTypes.node,
};

Alert.defaultProps = {
  className: null,
  children: null,
  showIcon: true,
  closable: false,
  type: 'warning',
  icon: null,
};

export default Alert;
